// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1f10e649","977":"2e3d5464"}[chunkId] + ".chunk.js";
};